import Vuex from "vuex";
import Vue from "vue";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
const ls = new SecureLS({ isCompression: false });

import * as states from "./states";
import astec from "./modules/astec";
import * as actions from "./actions";
import * as mutations from "./mutations";
import relatoOcorrencia from "@/features/relato-ocorrencia/store";
import acompanhamentoMensal from "@/features/campanha/acompanhamento-mensal/store";
import createPersistAsteсPaginacaoPlugin from "./modules/astec/utils/persistAsteсPaginacao";
import campanhaPendenciaPlugin from "@/features/campanha/shared/plugin/campanhaPendenciaPlugin";
import createPersistRelatoListagemPlugin from "@/features/relato-ocorrencia/store/persistListagem.plugin";

Vue.use(Vuex);

const asteсPaginacaoPlugin = createPersistAsteсPaginacaoPlugin(ls);

export default new Vuex.Store({
  state: states.estado,
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key)
      }
    }),
    asteсPaginacaoPlugin,
    campanhaPendenciaPlugin,
    createPersistRelatoListagemPlugin()
  ],
  modules: {
    astec,
    relatoOcorrencia,
    acompanhamentoMensal
  },
  mutations,
  actions,
  getters: states.getters
});
